import { has } from 'lodash-es'
import { UpgradeRegistryItem } from '../upgrader.types'
/**
 * component 对应组件类型
 * form 从某个版本开始升级
 * to 升级到的版本
 * upgrade 升级方法，具体的值
 *  {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 添加 autoFitHeight 属性，默认为 false
        // if (!('autoFitHeight' in schema.prop)) {
        //   schema.prop.autoFitHeight = false
        // }
        return schema
      }
    }
 */
export const HHDatetimePicker: UpgradeRegistryItem = {
  component: 'HHDatetimePicker',
  upgrades: [
    {
      from: 2,
      to: 3,
      upgrade(schema) {
        if (has(schema, 'prop') && !has(schema.prop, 'customTimeType')) {
          schema.prop.customTimeType = 'day'
        }
        if (
          has(schema, 'prop') &&
          has(schema.prop, 'limitRange') &&
          !has(schema.prop.limitRange, 'timeType')
        ) {
          schema.prop.limitRange.timeType = 'day'
        }
        return schema
      }
    }
  ]
}
